if (!customElements.get('header-menu')) {
  class HeaderMenu extends HTMLElement {
    constructor() {
      super();
      this.headerActions = this.querySelector('[data-header-actions]');
      this.root = document.documentElement;
      this.header = document.querySelector('header');
      this.section = this.header?.closest('.shopify-section');
      this.main = document.querySelector('#MainContent');
      this.group = document.querySelector('.shopify-section-group-header-group');
      this.lastY = 0;
      this.delta = 0;
    }

    connectedCallback() {
      this.addDelegatedClickListeners();
      this.setHeaderHeightVar();
      this.initScrollBehavior();
    }

    getMinHeight() {
      return window.innerWidth < 768 ? 64 : 72;
    }

    setFullHeaderHeight() {
      const top = this.main?.getBoundingClientRect().top || 0;
      if (this.group) {
        this.root.style.setProperty(
          '--full-header-height',
          `${Math.max(top, this.getMinHeight())}px`
        );
      }
    }

    setHeaderHeightVar() {
      const top = this.main?.getBoundingClientRect().top || 0;
      const offset = this.main?.offsetTop || 0;

      if (this.group) {
        this.root.style.setProperty(
          '--header-height',
          `${Math.max(top, this.getMinHeight())}px`
        );
      }

      this.root.style.setProperty(
        '--desktop-top',
        `${window.scrollY > offset ? 0 : offset}px`
      );
    }

    onScroll() {
      const y = window.scrollY;
      const down = y > this.lastY;

      if (down) {
        this.delta += y - this.lastY;
        if (this.delta >= 200) {
          this.section?.classList.add('-sp-translate-y-[200%]');
          this.root.style.setProperty('--header-height', '0px');
          this.root.style.setProperty('--full-header-height', '0px');
        } else {
          this.setFullHeaderHeight();
        }
      } else {
        this.delta = 0;
        this.section?.classList.remove('-sp-translate-y-[200%]');
        this.setFullHeaderHeight();
        this.setHeaderHeightVar();
      }

      if (this.group) {
        document.body.classList.toggle('at-top', y < 200);
      }

      this.lastY = Math.max(y, 0);
    }

    initScrollBehavior() {
      this.setFullHeaderHeight();
      ['scroll', 'resize', 'load'].forEach(e =>
        window.addEventListener(e, () => {
          this.onScroll();
          this.setHeaderHeightVar();
        })
      );
    }

    addDelegatedClickListeners() {
      this.addEventListener('resize', this.setHeaderHeightVar);
      this.addEventListener('mouseover', (e) => {
        if (e.target.closest('[data-desktop-nav-item]')) {
          this.querySelectorAll('[data-desktop-nav-item].active').forEach(x => x.classList.remove('active'));
          e.target.closest('[data-desktop-nav-item]').classList.add('active');
        }
        if (!e.target.closest('nav') || e.target.closest('[data-overlay]')) {
          this.querySelectorAll('[data-desktop-nav-item].active').forEach(x => x.classList.remove('active'));
        }
      });

      this.addEventListener('click', (e) => {
        if (this.handleCountryDropdownClick(e)) return;

        const mobileDrawer = this.querySelector(`[data-mobile-drawer${ this.useVariant ? '-variant' : '' }]`),
              mobileInner = this.querySelectorAll('[data-inner-menu]'),
              clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;

        const { action, submenu } = clickedElement.dataset;

        switch (action) {
          case 'dropdown':
            if (clickedElement.parentElement.classList.contains('active')) {
              clickedElement.parentElement.classList.remove('active');
              return;
            }
            this.querySelectorAll('[data-desktop-nav-item].active').forEach(x => x.classList.remove('active'));
            clickedElement.parentElement.classList.add('active');
          break;
          case 'toggle-menu':
            document.body.classList.toggle('sp-overflow-hidden');
            clickedElement.classList.toggle('active');
            mobileDrawer.classList.toggle('-sp-translate-x-full');
            mobileInner.forEach(panel => {
              panel.classList.remove('-sp-translate-x-1/3', 'sp-opacity-0');
            });
            this.querySelector(`.open[data-mobile-drawer-submenu${ this.useVariant ? '-variant' : '' }]`)?.classList.add('sp-translate-x-full');
          break;
          // case 'open-submenu':
          //   if (!submenu) return;
          //   this.querySelector(`[data-mobile-drawer-submenu${ this.useVariant ? '-variant' : '' }="${submenu}"]`)?.classList.remove('sp-translate-x-full');
          //   this.querySelector(`[data-mobile-drawer-submenu${ this.useVariant ? '-variant' : '' }="${submenu}"]`)?.classList.add('open');
          //   mobileInner.forEach(panel => {
          //     panel.classList.add('-sp-translate-x-1/3', 'sp-opacity-0');
          //   });
          //   break;
          // case 'close-submenu':
          //   if (!submenu) return;
          //   this.querySelector(`[data-mobile-drawer-submenu${ this.useVariant ? '-variant' : '' }="${submenu}"]`)?.classList.add('sp-translate-x-full');
          //   this.querySelector(`[data-mobile-drawer-submenu${ this.useVariant ? '-variant' : '' }="${submenu}"]`)?.classList.remove('open');
          //   mobileDrawer.classList.remove('-translate-x-full');
          //   mobileInner.forEach(panel => {
          //     panel.classList.remove('-sp-translate-x-1/3', 'sp-opacity-0');
          //   });
          //   break;
        }
      });

      this.querySelectorAll('[data-action="dropdown"]').forEach(el => {
        let menu = el.parentElement.querySelector('[data-overlay-sibling]');
        el.addEventListener('mouseenter', () => {
          menu.setAttribute('aria-expanded', 'true');
        });
        el.addEventListener('mouseleave', () => {
          menu.setAttribute('aria-expanded', 'false');
        });
        el.addEventListener('focus', () => {
          this.querySelectorAll('[data-overlay-sibling]').forEach(sub => {
            sub.setAttribute('aria-expanded', 'false');
          });
          menu.getAttribute('aria-expanded') == 'false'
            ? menu.setAttribute('aria-expanded', 'true')
            : menu.setAttribute('aria-expanded', 'false');
        });
      });
    }

    handleCountryDropdownClick(e) {
      const toggle = e.target.closest('[data-country-toggle]');
      const dropdown = e.target.closest('[data-country-dropdown]');

      this.querySelectorAll('[data-country-dropdown]').forEach(dd => {
        const t = dd.querySelector('[data-country-toggle]');
        const l = dd.querySelector('[data-country-list]');
        if (!t || !l) return;

        if (!dropdown || dd !== dropdown || !toggle) {
          l.classList.add('sp-hidden');
          t.setAttribute('aria-expanded', 'false');
        }
      });

      if (!toggle || !dropdown) return false;

      const list = dropdown.querySelector('[data-country-list]');
      if (!list) return false;

      e.preventDefault();
      e.stopPropagation();

      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      list.classList.toggle('sp-hidden');

      return true;
    }
  }

  customElements.define('header-menu', HeaderMenu);
}
